import { service } from '../axios';
/** 维修报表汇总 */
export function getRepairReportSummary() {
    return service({
        url: '/report/summary',
        method: 'get'
    });
}
/** 实验室维修分析（按时间区间） */
export function getDeptRepairAnalysisReport(params) {
    return service({
        url: '/report/deptRepairAnalysis',
        method: 'get',
        params
    });
}
/** 教育分类号前4位故障率分析 */
export function getEduCategory4FaultAnalysisReport() {
    return service({
        url: '/report/eduCategoryFaultAnalysis',
        method: 'get'
    });
}
export function getRepairReport(params) {
    return service({
        url: '/report/getRepairReport',
        method: 'get',
        params
    });
}
